<script setup>
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";

const { smallerOrEqual } = useBreakpoints(breakpointsBootstrapV5);

const isMobileView = smallerOrEqual("xl");
</script>

<template>
  <div
    class="layout-block"
    :class="{ 'layout-block--mobile': isMobileView }"
  >
    <div class="layout-block__title">
      <slot name="block-title" />
    </div>
    <div class="layout-block__content">
      <slot name="block-content" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@tinyurldev/tu-ui-vue/scss/settings/spacing.scss" as spacing;
@use "@tinyurldev/tu-ui-vue/scss/settings/typography.scss" as typography;

$title-width: 170px;

.layout-block {
  $self: &;

  display: flex;
  align-items: flex-start;
  gap: spacing.$xxs;
  margin-bottom: spacing.$xxs;

  &__title {
    flex-basis: $title-width;
    flex-shrink: 0;

    h6 {
      font-weight: typography.$font-weight-bold;
      margin-bottom: 0;
    }
  }
  &__content {
    flex-grow: 1;
  }

  &--mobile {
    flex-direction: column;
    position: relative;

    #{$self}__title {
      flex-basis: auto;
    }
    #{$self}__content {
      width: 100%;
    }
  }
}
</style>
